module.exports = __webpack_public_path__ + "static/assets/edc2ebe68d89ad4fa4dacbf54c724f82.png";